<template>
<div class="card box-shadow-sm bg-light mx-auto pb-3 pb-sm-0" style="max-width: 700px">
  <div class="product-badge product-available text-dark" style="right: -0.8rem; top: 0%; background-color: rgb(1,255,219)">
    <i class="czi-security-check"></i>
    Online Bewertung
  </div> 
  <div class="card-body">
    <p class="text-center text-dark h5 mb-3 pb-2 mt-3">Was ist deine Küche Wert?</p>
    <!-- Dark progress bar -->
    <div class="progress mb-1" style="height: 4px;">
      <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + progressPct + '%'"
        :aria-valuenow="progressPct" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>
    <div class="tab-content">
      <div class="tab-pane show active" id="formTab" role="tabpanel">
        <p :class="questionCss">Welche Form hat die Küche?</p>
        <div class="container">
          <div class="row justify-content-between">
              <a href="#styleTab"  v-for="(kitchenStyle, idx) in kitchenForms" :key="idx"
                :class="kitchenStyle.cssClass" data-toggle="tab" role="tab" @click="() => {formChosen(kitchenStyle.name, idx)}"
              >
                <img class="my-2" :src="kitchenStyle.imgPath" width="122" :alt="kitchenStyle.name"> 
                <p class="text-dark font-size-md pt-2 mb-0" style="color: #000000 !important">{{kitchenStyle.name}}</p>
              </a>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="styleTab" role="tabpanel">
        <p :class="questionCss">Welchem Stil entspricht die Küche?</p>
        <div class="container">
          <div class="row justify-content-between">
              <a href=""  v-for="(kitchenStyle, idx) in kitchenStyles" :key="idx"
                :class="kitchenStyle.cssClass" data-toggle="tab" role="tab" @click="() => {openProducts(kitchenStyle.name, idx)}"
              >
                <img class="my-2" :src="kitchenStyle.imgPath" width="122" :alt="kitchenStyle.name"> 
                <p class="text-dark font-size-md pt-2 mb-0" style="color: #000000 !important">{{kitchenStyle.name}}</p>
              </a>
          </div>
        </div>
      </div> 
    </div>
    <div class="container">
      <div class="d-none d-md-flex mt-4 row justify-content-around" style="opacity: 0.4">
        <div class="d-flex align-items-center justify-content-center col-3">
          <i class="czi-check mb-0 font-size-xs text-muted mt-1 mr-1"></i>
          <div class="pl-2">
            <div class="text-muted font-size-xs text-left">Schnelle</div>
            <div class="text-muted font-size-xs">Wertorientierung</div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center col-3">
          <i class="czi-check mb-0 font-size-xs text-muted mt-1 mr-1"></i>
          <div class="pl-2">
            <div class="text-muted font-size-xs text-left">Nur</div>
            <div class="text-muted font-size-xs">3 Schritte</div> 
          </div>
        </div> 
        <div class="d-flex align-items-center justify-content-center col-3">
          <i class="czi-check mb-0 font-size-xs text-muted mt-1 mr-1"></i>
          <div class="pl-2">
            <div class="text-muted font-size-xs text-left">100%</div>
            <div class="text-muted font-size-xs">Kostenlos</div>
          </div>
        </div> 
        <div class="d-flex align-items-center justify-content-center col-3">
          <i class="czi-locked mb-0 font-size-xl text-muted mt-1 mr-1"></i>
          <div class="pl-2">
            <div class="text-muted font-size-xs text-left">SLL</div>
            <div class="text-muted font-size-xs">Datensicherheit</div>
          </div>
        </div> 
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'evaluate',
  components: {
  },
  data: function () { 
    const kitchenCss = "col-6 col-md-3 my-2 bg-white border box-shadow rounded-0 text-center nav-link borderOnHover";
    return {
      measureForm: {imgPath: "img/uForm.png", cssClass: ""},
      kitchenForms: [
        {imgPath: "img/myDesigns/forms/zeile-base.svg", name: "Zeile", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/forms/lForm-base.svg", name: "L-Form", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/forms/uForm-base.svg", name: "U-Form", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/forms/sonstiges-base.svg", name: "Sonstiges", cssClass: kitchenCss + ""},
      ],
      kitchenStyles: [
        {imgPath: "img/myDesigns/styles/modern-base.svg", name: "Modern", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/styles/classic-base.svg", name: "Klassisch", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/styles/landhaus-base.svg", name: "Landhaus", cssClass: kitchenCss + ""},
        {imgPath: "img/myDesigns/styles/questionmark.svg", name: "Sonstiges", cssClass: kitchenCss + ""}, 
      ],
      progress: 0,
      progressPct: 0,
      questionCss: "card-title text-center font-size-lg mb-2 py-4 text-dark",
      form: null,
      formID: null,
    }
  },
  computed: {
  },
  created: function () {
    this.progress++;
  },
  mounted: function () {
  },
  watch: {
    progress: function (val) {
      this.progressPct = Math.ceil(val * 33.3);
    }
  },
  methods: {
    ...mapActions(['evalManagerDispatch']),
    formChosen: function (form, id) {
      this.progress++;
      this.form = form;
      this.formID = id;
    },
    openProducts: async function (style, id) {
      this.progress = 2;
      const formAndStyle = {form: this.form, style: style, formID: this.formID.toString(), styleID: id.toString()};
      window.myGTag('event', 'conversion', {'send_to': 'AW-717328684/Br2oCKebrNUBEKyihtYC'}); 
      await this.evalManagerDispatch({action: "evaluationDetails", payload: formAndStyle});
      this.$router.push({path: "bewertung"});
    }
  }
}


</script>

<style scoped>
.borderOnHover{
  border: 3px solid rgba(0, 0, 0, 0.0) !important;
  box-shadow: rgba(0, 50, 150, 0.1) 0px 0px 1em 0.1em !important;
}

.borderOnHover:hover {
  border: 3px solid darkorange !important
}

.product-badge.product-available::after {
  border-bottom-color: rgb(1,255,219) !important;
}
</style>